function toFixed(num: number, fixed: number) {
    const re = new RegExp(`^-?\\d+(?:.\\d{0,${fixed || -1}})?`);
    return num.toString().match(re)[0];
}

export const squeezeNumber = (number: number | string) => {
  if (number === undefined || number === "") return "";

  if (typeof number !== "number") {
    throw new TypeError("Parameter is not a number");
  }

  const rules = [
    { threshold: 1000000000000, label: "tri" },
    { threshold: 1000000000, label: "bi" },
    { threshold: 1000000, label: "mi" },
    { threshold: 1000, label: "k" },
  ];

  const applicableRule = rules.find((rule) => number >= rule.threshold);

  if (applicableRule) {
    const fixedNumber = toFixed(number / applicableRule.threshold, 1);
    return fixedNumber.replace(/\.0$/, "") + applicableRule.label;
  }

  return String(number);
};
